const API_BASE =
  process.env.REACT_APP_API_BASE_URL || '/api/v1/candidate-assemblies';

export function apiRequest(path, options = {}, token = null) {
  const headers = { Accept: 'application/json; charset=utf-8', ...(options.headers || {}) };
  if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json; charset=utf-8';
  if (token) headers.Authorization = `Bearer ${token}`;

  return fetch(`${API_BASE}${path}`, { ...options, headers }).then(async (res) => {
    const buffer = await res.arrayBuffer();
    const raw = new TextDecoder('utf-8').decode(buffer);
    let payload = {};
    try { payload = raw ? JSON.parse(raw) : {}; } catch (_) { /* noop */ }
    if (!res.ok) throw new Error(payload?.message || payload?.errorCode || 'Error en la solicitud.');
    if (!Object.prototype.hasOwnProperty.call(payload, 'data'))
      throw new Error('Respuesta invalida del servidor. Verifica conexion del backend.');
    return payload.data;
  }).catch((err) => {
    if (err instanceof SyntaxError) throw new Error('Respuesta invalida del servidor.');
    throw err;
  });
}
